import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';

const ViewToggleDropdown = ({ activeView, onToggle, loading = false }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleDropdownToggle = (isOpen) => {
        setDropdownOpen(isOpen);
    };

    const handleViewChange = (view) => {
        onToggle(view);
        setDropdownOpen(false);
    };

    return (
        <div className="d-flex align-items-center">
            <span className="me-2 small text-muted">View:</span>
            <Dropdown
                className="custom-drop-down"
                show={dropdownOpen}
                onToggle={handleDropdownToggle}
            >
                <Dropdown.Toggle
                    className="bg-gradient border-0 py-2 px-3"
                    variant="success"
                    id="view-toggle-dropdown"
                    disabled={loading}
                >
                    {activeView === 'daily' ? 'Daily' : 'Monthly'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="bg-gradient">
                    <Dropdown.Item
                        onClick={() => handleViewChange('daily')}
                        className={activeView === 'daily' ? 'active' : ''}
                    >
                        Daily
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => handleViewChange('monthly')}
                        className={activeView === 'monthly' ? 'active' : ''}
                    >
                        Monthly
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default ViewToggleDropdown; 